import { StyleFn } from '..'

// minimalistic css reset that will benefit every one
// don't set any style here that could conflict with custom app styles
export const Baseline: StyleFn = (theme) => {
  const { color, font } = theme
  const textStyles = Text(theme)
  return {
    '@global': {
      html: {
        boxSizing: 'border-box',
      },
      '*, *::before, *::after': {
        boxSizing: 'border-box',
      },
      body: {
        margin: 0,
        fontFamily: font.family,
        fontSize: font.size.medium,
        lineHeight: font.lineheight.medium,
        '@media print': {
          backgroundColor: color.palette.white,
        },
      },
      // optin global styles
      '.ds-styles': {
        color: color.getModalValues(color.text.primary),
        backgroundColor: color.getModalValues(color.background.primary),
        '& h1': textStyles._h1,
        '& h2': textStyles._h2,
        '& h3': textStyles._h3,
        '& h4': textStyles._h4,
        '& h5': textStyles._h5,
        '& h6': textStyles._h6,
      },
    },
  }
}

export const Text: StyleFn = ({ color, font, size }) => {
  const heading = {
    fontFamily: font.family,
    fontWeight: font.weight.bold,
    color: color.type === 'light' ? color.brand.normal : color.palette.white,
    marginTop: 0,
    marginBottom: size.spacing[8],
  }
  const primaryColor = {
    color: color.getModalValues(color.text.primary),
  }
  const styles: any = {
    root: primaryColor,
    _body: primaryColor,
    _heading: {
      color: color.type === 'light' ? color.brand.normal : color.palette.white,
    },
    _label: {
      color: color.getModalValues(color.text.secondary),
    },
    _legend: {
      color: color.getModalValues(color.text.tertiary),
    },
    _h1: {
      ...heading,
      fontSize: font.size['heading-1'],
      lineHeight: font.lineheight['heading-1'],
    },
    _h2: {
      ...heading,
      fontSize: font.size['heading-2'],
      lineHeight: font.lineheight['heading-2'],
    },
    _h3: {
      ...heading,
      fontSize: font.size['heading-3'],
      lineHeight: font.lineheight['heading-3'],
    },
    _h4: {
      ...heading,
      fontSize: font.size['heading-4'],
      lineHeight: font.lineheight['heading-4'],
      fontWeight: font.weight.medium,
    },
    _h5: {
      ...heading,
      fontSize: font.size['heading-5'],
      lineHeight: font.lineheight['heading-5'],
      fontWeight: font.weight.medium,
    },
    _h6: {
      ...heading,
      fontSize: font.size['heading-6'],
      lineHeight: font.lineheight['heading-6'],
      fontWeight: font.weight.medium,
    },
    _noGutter: {
      marginBottom: 0,
    },
  }
  ;['xsmall', 'small', 'medium', 'large'].forEach((size: 'xsmall' | 'small' | 'medium' | 'large') => {
    styles[`_${size}`] = {
      fontSize: font.size[size],
      lineHeight: font.lineheight[size],
    }
  })
  return styles
}

/** Utilities for Screenreaders */
export const SROnly: StyleFn = () => {
  return {
    // FIXME could be replaced with https://polished.js.org/docs/#hidevisually
    root: {
      position: 'absolute',
      width: 1,
      height: 1,
      margin: -1,
      overflow: 'hidden',
      clip: 'rect(0,0,0,0)',
    },
    _focusable: {
      position: 'static',
      width: 'auto',
      height: 'auto',
      margin: 0,
      overflow: 'visible',
      clip: 'auto',
    },
  }
}
